/* This function is completely auto-generated via the `pnpm bootstrap` phase of
  the app. You can re-run it when adding new localized handbook pages by running:

  pnpm run --filter=documentation create-handbook-nav

  Find the source of truth at packages/documentation/scripts/generateDocsNavigationPerLanguage.js
*/

import type { SidebarNavItem } from "./documentationNavigationUtils";

export function getDocumentationNavForLanguage(
  langRequest: string
): SidebarNavItem[] {
  const langs = ["en"];
  const lang = langs.includes(langRequest) ? langRequest : "en";
  const navigations: Record<string, SidebarNavItem[]> = {};

  navigations.en = [
    {
      title: "新手上路",
      oneline: "根据你的背景或偏好快速介绍。",
      id: "新手上路",
      chronological: false,

      items: [
        {
          title: "面向新程序员的 TS",
          id: "0-typescript-for-the-new-programmer",
          permalink: "/docs/handbook/typescript-from-scratch.html",
          oneline: "从零开始学习 TypeScript",
        },
        {
          title: "面向 JS 程序员的 TypeScript",
          id: "0-typescript-for-javascript-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes.html",
          oneline: "了解 TypeScript 如何扩展 JavaScript",
        },
        {
          title: "面向 Java/C# 程序员的 TS",
          id: "0-typescript-for-java/c#-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes-oop.html",
          oneline: "如果你有面向对象语言的背景，学习 TypeScript",
        },
        {
          title: "面向函数式程序员的 TS",
          id: "0-typescript-for-functional-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes-func.html",
          oneline: "如果你有函数式编程的背景，学习 TypeScript",
        },
        {
          title: "5 分钟了解 TypeScript 工具",
          id: "0-typescript-tooling-in-5-minutes",
          permalink: "/docs/handbook/typescript-tooling-in-5-minutes.html",
          oneline: "了解如何使用 TypeScript 创建小型网站的教程",
        },
      ],
    },
    {
      title: "手册",
      oneline: "对于你的日常 TS 工作来说，这是很棒的入门读物。",
      id: "手册",
      chronological: true,

      items: [
        {
          title: "TypeScript 手册",
          id: "1-the-typescript-handbook",
          permalink: "/docs/handbook/intro.html",
          oneline: "学习 TypeScript 的第一步",
        },
        {
          title: "基础知识",
          id: "1-the-basics",
          permalink: "/docs/handbook/2/basic-types.html",
          oneline: "学习 TypeScript 的第一步：基本类型。",
        },
        {
          title: "日常类型",
          id: "1-everyday-types",
          permalink: "/docs/handbook/2/everyday-types.html",
          oneline: "语言基础类型。",
        },
        {
          title: "类型缩小",
          id: "1-narrowing",
          permalink: "/docs/handbook/2/narrowing.html",
          oneline:
            "了解 TypeScript 如何使用 JavaScript 知识来减少项目中的类型语法数量。",
        },
        {
          title: "更多关于函数",
          id: "1-more-on-functions",
          permalink: "/docs/handbook/2/functions.html",
          oneline: "了解函数在 TypeScript 中的工作原理。",
        },
        {
          title: "对象类型",
          id: "1-object-types",
          permalink: "/docs/handbook/2/objects.html",
          oneline: "TypeScript 如何描述 JavaScript 对象的形状。",
        },
        {
          title: "类型操作",
          id: "1-类型操作",
          oneline: "undefined",
          chronological: true,

          items: [
            {
              title: "从类型创建类型",
              id: "1-creating-types-from-types",
              permalink: "/docs/handbook/2/types-from-types.html",
              oneline: "概述从现有类型创建更多类型的方法。",
            },
            {
              title: "泛型",
              id: "1-generics",
              permalink: "/docs/handbook/2/generics.html",
              oneline: "带参数的类型",
            },
            {
              title: "keyof 类型运算符",
              id: "1-keyof-type-operator",
              permalink: "/docs/handbook/2/keyof-types.html",
              oneline: "在类型上下文中使用 keyof 运算符。",
            },
            {
              title: "typeof 类型运算符",
              id: "1-typeof-type-operator",
              permalink: "/docs/handbook/2/typeof-types.html",
              oneline: "在类型上下文中使用 typeof 运算符。",
            },
            {
              title: "索引访问类型",
              id: "1-indexed-access-types",
              permalink: "/docs/handbook/2/indexed-access-types.html",
              oneline: "使用 Type['a'] 语法访问类型的子集。",
            },
            {
              title: "条件类型",
              id: "1-conditional-types",
              permalink: "/docs/handbook/2/conditional-types.html",
              oneline: "创建类似于类型系统中的 if 语句的类型。",
            },
            {
              title: "映射类型",
              id: "1-mapped-types",
              permalink: "/docs/handbook/2/mapped-types.html",
              oneline: "通过重新使用现有类型来生成类型。",
            },
            {
              title: "模板字面类型",
              id: "1-template-literal-types",
              permalink: "/docs/handbook/2/template-literal-types.html",
              oneline: "生成通过模板字面字符串更改属性的映射类型。",
            },
          ],
        },
        {
          title: "类",
          id: "1-classes",
          permalink: "/docs/handbook/2/classes.html",
          oneline: "TypeScript 中的类是如何工作的",
        },
        {
          title: "模块",
          id: "1-modules",
          permalink: "/docs/handbook/2/modules.html",
          oneline: "JavaScript 如何处理跨文件边界的通信。",
        },
      ],
    },
    {
      title: "参考",
      oneline: "深入探讨参考资料。",
      id: "参考",
      chronological: false,

      items: [
        {
          title: "工具类型",
          id: "2-utility-types",
          permalink: "/docs/handbook/utility-types.html",
          oneline: "TypeScript 中全局包含的类型",
        },
        {
          title: "备忘单",
          id: "2-备忘单",
          permalink: "/cheatsheets",
          oneline: "Syntax overviews for common code",
        },
        {
          title: "装饰器",
          id: "2-decorators",
          permalink: "/docs/handbook/decorators.html",
          oneline: "TypeScript 装饰器概述",
        },
        {
          title: "声明合并",
          id: "2-declaration-merging",
          permalink: "/docs/handbook/declaration-merging.html",
          oneline: "合并命名空间和接口的工作原理",
        },
        {
          title: "枚举",
          id: "2-enums",
          permalink: "/docs/handbook/enums.html",
          oneline: "TypeScript 枚举的工作原理",
        },
        {
          title: "迭代器和生成器",
          id: "2-iterators-and-generators",
          permalink: "/docs/handbook/iterators-and-generators.html",
          oneline: "迭代器和生成器如何在 TypeScript 中工作",
        },
        {
          title: "JSX",
          id: "2-jsx",
          permalink: "/docs/handbook/jsx.html",
          oneline: "将 JSX 与 TypeScript 结合使用",
        },
        {
          title: "混入",
          id: "2-mixins",
          permalink: "/docs/handbook/mixins.html",
          oneline: "在 TypeScript 中使用混合模式",
        },
        {
          title: "命名空间",
          id: "2-namespaces",
          permalink: "/docs/handbook/namespaces.html",
          oneline: "TypeScript 命名空间的工作原理",
        },
        {
          title: "命名空间和模块",
          id: "2-namespaces-and-modules",
          permalink: "/docs/handbook/namespaces-and-modules.html",
          oneline: "如何通过模块或命名空间在 TypeScript 中组织代码",
        },
        {
          title: "符号",
          id: "2-symbols",
          permalink: "/docs/handbook/symbols.html",
          oneline: "在 TypeScript 中使用 JavaScript 符号基础类型",
        },
        {
          title: "三斜杠指令",
          id: "2-triple-slash-directives",
          permalink: "/docs/handbook/triple-slash-directives.html",
          oneline: "如何在 TypeScript 中使用三重斜杠指令",
        },
        {
          title: "类型兼容性",
          id: "2-type-compatibility",
          permalink: "/docs/handbook/type-compatibility.html",
          oneline: "类型检查在 TypeScript 中的工作原理",
        },
        {
          title: "类型推断",
          id: "2-type-inference",
          permalink: "/docs/handbook/type-inference.html",
          oneline: "代码流分析在 TypeScript 中的工作原理",
        },
        {
          title: "变量声明",
          id: "2-variable-declaration",
          permalink: "/docs/handbook/variable-declarations.html",
          oneline: "TypeScript 如何处理变量声明",
        },
      ],
    },
    {
      title: "模块参考",
      oneline: "TypeScript 如何对 JavaScript 模块进行建模。",
      id: "模块参考",
      chronological: false,

      items: [
        {
          title: "介绍",
          id: "3-modules---introduction",
          permalink: "/docs/handbook/modules/introduction.html",
          oneline: "TypeScript 如何对 JavaScript 模块进行建模",
        },
        {
          title: "理论",
          id: "3-modules---theory",
          permalink: "/docs/handbook/modules/theory.html",
          oneline: "TypeScript 如何对 JavaScript 模块进行建模",
        },
        {
          title: "指南",
          id: "3-指南",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "选择编译器选项",
              id: "3-modules---choosing-compiler-options",
              permalink:
                "/docs/handbook/modules/guides/choosing-compiler-options.html",
              oneline: "如何选择反映你的模块环境的编译器选项",
            },
          ],
        },
        {
          title: "参考",
          id: "3-modules---reference",
          permalink: "/docs/handbook/modules/reference.html",
          oneline: "模块语法和编译器选项参考",
        },
        {
          title: "附录",
          id: "3-附录",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "ESM/CJS 互操作性",
              id: "3-modules---esm/cjs-interoperability",
              permalink:
                "/docs/handbook/modules/appendices/esm-cjs-interop.html",
              oneline: "详细了解 ES 模块和 CommonJS 模块之间的互操作性",
            },
          ],
        },
      ],
    },
    {
      title: "教程",
      oneline: "在多种环境中使用 TypeScript。",
      id: "教程",
      chronological: false,

      items: [
        {
          title: "ASP.NET 核心",
          id: "4-asp.net-core",
          permalink: "/docs/handbook/asp-net-core.html",
          oneline: "在 ASP.NET 核心中使用 TypeScript",
        },
        {
          title: "Gulp",
          id: "4-gulp",
          permalink: "/docs/handbook/gulp.html",
          oneline: "将 TypeScript 与 Gulp 结合使用",
        },
        {
          title: "DOM 操作",
          id: "4-dom-manipulation",
          permalink: "/docs/handbook/dom-manipulation.html",
          oneline: "将 DOM 与 TypeScript 一起使用",
        },
        {
          title: "从 JavaScript 迁移",
          id: "4-migrating-from-javascript",
          permalink: "/docs/handbook/migrating-from-javascript.html",
          oneline: "如何从 JavaScript 迁移到 TypeScript",
        },
        {
          title: "将 Babel 与 TypeScript 结合使用",
          id: "4-using-babel-with-typescript",
          permalink: "/docs/handbook/babel-with-typescript.html",
          oneline: "如何创建混合 Babel + TypeScript 项目",
        },
      ],
    },
    
    {
      title: "声明文件",
      oneline:
        "了解如何编写声明文件来描述现有的 JavaScript。 对于 DefinitelyTyped 贡献很重要。",
      id: "声明文件",
      chronological: true,

      items: [
        {
          title: "介绍",
          id: "6-introduction",
          permalink: "/docs/handbook/declaration-files/introduction.html",
          oneline: "如何编写高质量的 TypeScript 声明 (d.ts) 文件",
        },
        {
          title: "声明参考手册",
          id: "6-declaration-reference",
          permalink: "/docs/handbook/declaration-files/by-example.html",
          oneline: "如何为模块创建 d.ts 文件",
        },
        {
          title: "库结构",
          id: "6-library-structures",
          permalink: "/docs/handbook/declaration-files/library-structures.html",
          oneline: "如何构建你的 d.ts 文件",
        },
        {
          title: ".d.ts 模板",
          id: "6-.d.ts-模板",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "模块 .d.ts",
              id: "6-modules-.d.ts",
              permalink:
                "/docs/handbook/declaration-files/templates/module-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "模块：插件",
              id: "6-module:-plugin",
              permalink:
                "/docs/handbook/declaration-files/templates/module-plugin-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "模块：类",
              id: "6-module:-class",
              permalink:
                "/docs/handbook/declaration-files/templates/module-class-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "模块：函数",
              id: "6-module:-function",
              permalink:
                "/docs/handbook/declaration-files/templates/module-function-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "全局 .d.ts",
              id: "6-global-.d.ts",
              permalink:
                "/docs/handbook/declaration-files/templates/global-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "全局：修改模块",
              id: "6-global:-modifying-module",
              permalink:
                "/docs/handbook/declaration-files/templates/global-modifying-module-d-ts.html",
              oneline: "undefined",
            },
          ],
        },
        {
          title: "该做什么和不该做什么",
          id: "6-do's-and-don'ts",
          permalink: "/docs/handbook/declaration-files/do-s-and-don-ts.html",
          oneline: "编写 d.ts 文件的建议",
        },
        {
          title: "深入探讨",
          id: "6-deep-dive",
          permalink: "/docs/handbook/declaration-files/deep-dive.html",
          oneline: "深入探讨 d.ts 文件是如何工作的",
        },
        {
          title: "发布",
          id: "6-publishing",
          permalink: "/docs/handbook/declaration-files/publishing.html",
          oneline: "如何将你的 d.ts 文件提供给用户",
        },
        {
          title: "引用",
          id: "6-consumption",
          permalink: "/docs/handbook/declaration-files/consumption.html",
          oneline: "如何为你的项目下载 d.ts 文件",
        },
      ],
    },
    {
      title: "JavaScript",
      oneline: "如何使用 TypeScript 驱动的 JavaScript 工具。",
      id: "javascript",
      chronological: true,

      items: [
        {
          title: "使用 TypeScript 的 JS 项目",
          id: "7-js-projects-utilizing-typescript",
          permalink: "/docs/handbook/intro-to-js-ts.html",
          oneline: "如何使用 TypeScript 为 JavaScript 文件添加类型检查",
        },
        {
          title: "类型检查 JavaScript 文件",
          id: "7-type-checking-javascript-files",
          permalink: "/docs/handbook/type-checking-javascript-files.html",
          oneline: "如何使用 TypeScript 为 JavaScript 文件添加类型检查",
        },
        {
          title: "JSDoc 参考资料",
          id: "7-jsdoc-reference",
          permalink: "/docs/handbook/jsdoc-supported-types.html",
          oneline: "TypeScript 支持的 JavaScript 支持哪些 JSDoc？",
        },
        {
          title: "从 .js 文件创建 .d.ts 文件",
          id: "7-creating-.d.ts-files-from-.js-files",
          permalink: "/docs/handbook/declaration-files/dts-from-js.html",
          oneline: "如何为 JavaScript 项目添加 d.ts 生成",
        },
      ],
    },
    {
      title: "项目配置",
      oneline: "编译器配置参考。",
      id: "项目配置",
      chronological: false,

      items: [
        {
          title: "什么是 tsconfig.json",
          id: "8-what-is-a-tsconfig.json",
          permalink: "/docs/handbook/tsconfig-json.html",
          oneline: "了解 TSConfig 的工作原理",
        },
        {
          title: "MSBuild 中的编译器选项",
          id: "8-compiler-options-in-msbuild",
          permalink: "/docs/handbook/compiler-options-in-msbuild.html",
          oneline: "哪些编译器选项在 MSBuild 项目中可用。",
        },
        {
          title: "TSConfig 参考手册",
          id: "8-tsconfig-参考手册",
          permalink: "/tsconfig",
          oneline: "The page covering every TSConfig option",
        },
        {
          title: "tsc CLI 选项",
          id: "8-tsc-cli-options",
          permalink: "/docs/handbook/compiler-options.html",
          oneline: "tsc 的 CLI 编译器选项的高级概述",
        },
        {
          title: "项目引用",
          id: "8-project-references",
          permalink: "/docs/handbook/project-references.html",
          oneline: "如何拆分大型 TypeScript 项目",
        },
        {
          title: "与构建工具集成",
          id: "8-integrating-with-build-tools",
          permalink: "/docs/handbook/integrating-with-build-tools.html",
          oneline: "如何将 TypeScript 与其他构建工具一起使用",
        },
        {
          title: "配置监视",
          id: "8-configuring-watch",
          permalink: "/docs/handbook/configuring-watch.html",
          oneline: "如何配置 TypeScript 的监视模式",
        },
        {
          title: "每日构建",
          id: "8-nightly-builds",
          permalink: "/docs/handbook/nightly-builds.html",
          oneline: "如何使用每日构建的 TypeScript",
        },
      ],
    },
  ];

  return navigations[lang];
}
